export default __webpack_public_path__ + "static/media/ic_tenants.6cba6898.png";